module.exports = __webpack_public_path__ + "img/lte-cellular.244df02a.svg";